import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Button, message } from "antd";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";

const { Option } = Select;
const { TextArea } = Input;

const CustomConnectionModal = ({
  visible,
  onClose,
  connectorId,
  config, // if passed → edit mode, else → add mode
  onSuccess,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (config) {
      form.setFieldsValue({
        name: config.name,   // ✅ prefill connection name
        base_url: config.base_url,
        auth_url: config.auth_url,
        method: config.method,
        path: config.path,
        query_params_template: config.query_params_template
          ? JSON.stringify(config.query_params_template, null, 2)
          : "",
        body_template: config.body_template
          ? JSON.stringify(config.body_template, null, 2)
          : "",
        access_token_path: config.access_token_path,
      });
    } else {
      form.resetFields();
    }
  }, [config, form, visible]);
  

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      let queryParams = {};
      let bodyTemplate = {};

      try {
        queryParams = values.query_params_template
          ? JSON.parse(values.query_params_template)
          : {};
      } catch (e) {
        message.error("Invalid JSON in Query Params Template");
        return;
      }

      try {
        bodyTemplate = values.body_template
          ? JSON.parse(values.body_template)
          : {};
      } catch (e) {
        message.error("Invalid JSON in Body Template");
        return;
      }

      const payload = {
        connector_config: {
          name: values.name,   // include connection name
          connector_id: connectorId,
          base_url: values.base_url,
          auth_url: values.auth_url,
          method: values.method,
          path: values.path,
          auth_type: "oauth2", // hardcoded
          query_params_template: queryParams,
          body_template: bodyTemplate,
          access_token_path: values.access_token_path,
        },
      };
      

      if (config && config.id) {
        // EDIT (PUT)
        const apiService = new ApiService(
          `${BASE_URL}/connector_configs/${config.id}`,
          { "Content-Type": "application/json" },
          "PUT",
          payload
        );
        await apiService.makeCall();
        message.success("Connection updated successfully");
      } else {
        // ADD (POST)
        const apiService = new ApiService(
          `${BASE_URL}/connector_configs`,
          { "Content-Type": "application/json" },
          "POST",
          payload
        );
        await apiService.makeCall();
        message.success("Connection created successfully");
      }

      form.resetFields();
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("Error saving connection:", err);
      message.error("Failed to save connection");
    }
  };

  return (
    <Modal
      open={visible}
      title={config ? "Edit Connection" : "Add New Connection"}
      onCancel={onClose}
      bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSubmit}>
          Save
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
            label="Connection Name"
            name="name"
            rules={[{ required: true, message: "Connection name is required" }]}
        >
            <Input placeholder="My Salesforce Connection" />
        </Form.Item>

        <Form.Item
            label="Base URL"
            name="base_url"
            rules={[{ required: true, message: "Base URL is required" }]}
        >
            <Input placeholder="https://login.salesforce.com" />
        </Form.Item>

        <Form.Item
            label="Auth URL"
            name="auth_url"
            rules={[{ required: true, message: "Auth URL is required" }]}
        >
            <Input placeholder="https://login.salesforce.com/services/oauth2/token" />
        </Form.Item>

        <Form.Item
            label="Method"
            name="method"
            rules={[{ required: true, message: "Method is required" }]}
        >
            <Select>
            <Option value="POST">POST</Option>
            <Option value="GET">GET</Option>
            <Option value="PUT">PUT</Option>
            <Option value="PATCH">PATCH</Option>
            </Select>
        </Form.Item>

        <Form.Item
            label="Path"
            name="path"
            rules={[{ required: true, message: "Path is required" }]}
        >
            <Input placeholder="/services/oauth2/token" />
        </Form.Item>

        {/* JSON fields */}
        <Form.Item label="Query Params Template (JSON)" name="query_params_template">
            <TextArea rows={5} placeholder='{"grant_type":"password","client_id":"..."}' />
        </Form.Item>

        <Form.Item label="Body Template (JSON)" name="body_template">
            <TextArea rows={5} placeholder='{"key":"value"}' />
        </Form.Item>

        <Form.Item label="Access Token Path" name="access_token_path">
            <Input />
        </Form.Item>
        </Form>

    </Modal>
  );
};

export default CustomConnectionModal;
